import { forwardRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { useGetHsptlzFormCreatedFileInfo } from 'features/HsptlzForm/model';
import { withNamespace } from 'shared/lib';

import { bindContentDetail, bindSign, bindTableData, createLogo, createNonBenefit, createPdf } from '../lib';
import { useSavePdf } from '../model/useSavePdf';

const PdfForm = ({ children }) => {
  return children;
};
// 여기에 필요한 데이터 들을 저장 해야함!
// 아직 템플릿이 완성되지 않아서 작업하기 애매함. ( 두 번 작업 하게 될 가능성 농후 )
// 21 ~ 25에 작업 진행해야 할 듯.
const TemplateContainer = () => {
  const { contentCode } = useParams();
  const processFormData = useBoundStore((state) => state['hsptlzForm'].processFormData);
  const caregiverData = useBoundStore((state) => state['hsptlzForm'].caregiverData);
  const contentDetailData = useBoundStore((state) => state['hsptlzForm'].contentDetailData);
  const nonBenefitList = useBoundStore((state) => state['hsptlzForm'].nonBenefitList);
  const sign = useBoundStore((state) => state['hsptlzForm'].sign);

  const { data: fileInfo } = useGetHsptlzFormCreatedFileInfo(contentCode);

  const { setConsentFile } = useSavePdf();

  useEffect(() => {
    const pdfTempContainer = document.querySelector('.pdf-temp-container');
    if (!pdfTempContainer) return;

    const newFileInfo = { ...fileInfo, ...caregiverData };
    bindSign(sign);
    bindTableData(newFileInfo);
    bindContentDetail(contentDetailData);
    createNonBenefit(nonBenefitList);
    const pages = document.querySelectorAll(`.pdf-page`); // pdf의 1페이지를 나누는 기준
    createLogo(pages);
    createPdf(pages, setConsentFile);
  }, []);

  return <div dangerouslySetInnerHTML={{ __html: processFormData[contentCode]?.pdfTemplate }} />;
};

export default withNamespace(PdfForm, {
  TemplateContainer,
});

